import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=55dd9c65&scoped=true"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"
import style0 from "./Todo.vue?vue&type=style&index=0&id=55dd9c65&prod&lang=scss&scoped=true"
import style1 from "./Todo.vue?vue&type=style&index=1&id=55dd9c65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd9c65",
  null
  
)

export default component.exports